import { Table, TableBody, TableHead, TableRow } from '@mui/material';
import { GeneralTableBox, HeadTableCell, RowTableCell, NoDataSkeleton } from '../../../common';
import { INVOICE_QUERY_TABLE_COLUMNS } from '../constants/invoiceQueryConstants';

const InvoiceQueryDataTable = ({ data, isLoading, LoadingComponent }) => {
  return (
    <GeneralTableBox>
      <Table aria-label="invoice query table">
        <TableHead>
          <TableRow>
            {INVOICE_QUERY_TABLE_COLUMNS.map(col => (
              <HeadTableCell key={col.id}>{col.label}</HeadTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <LoadingComponent />
          ) : data ? (
            <TableRow>
              {INVOICE_QUERY_TABLE_COLUMNS.map(col => (
                <RowTableCell key={col.id}>
                  {col.render ? col.render(data) : data[col.id]}
                </RowTableCell>
              ))}
            </TableRow>
          ) : (
            <NoDataSkeleton />
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
  );
};

export default InvoiceQueryDataTable;
